import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Stack, Typography } from "@mui/material";
import { OfficeAvatar } from "../../components/OfficeAvatar";
import { RankChip } from "../../components/RankChip";
import { styles } from "./partners.styles";

const FIELDS = [
  { key: "unicityId", label: "UID", isMatched: false },
  { key: "email", label: "Email", isMatched: false },
  { key: "homePhone", label: "Phone", isMatched: false }
]

const HighlightedField = ({ value, highlight }) => {
  const parts = value.split(new RegExp(`(${highlight})`, 'gi'))
  return (
    <span>
      {parts.map((part, i) => (
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={i} style={{ fontWeight: styles.searchBar.highlightWeight }}>
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      ))}
    </span>
  )
}

const PartnersSearchSuggestionItem = ({ item, searchTerm, setOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isNameMatched = item?.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
  const matchedFields = FIELDS.map(field => ({ ...field, isMatched: item[field.key] && item[field.key].toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 }))

  const firstInitial = item.name?.charAt(0);

  const handleItemClick = () => {
    setOpen(false);
    navigate(`${location.pathname}?drawer=partner&id=${item.unicityId}&drawerContent=profile`)
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      onClick={handleItemClick}
      sx={{
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#f5f5f5"
        },
        borderRadius: 2,
        padding: 1
      }}
    >
      <OfficeAvatar
        firstInitial={firstInitial}
      />
      <Stack direction="column">
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
        >
          {isNameMatched ? (
            <Typography variant="h5"><HighlightedField value={item.name} highlight={searchTerm} /></Typography>
          ) : (
            <Typography variant="h5">{item.name}</Typography>
          )}
          <RankChip
            nextRankId={item.nextRankId}
            styles={styles.rankChip}
          />
        </Stack>
        {matchedFields.map(field => {
          const { key, label, isMatched } = field
          return (isMatched ? (
            <Typography key={key} variant="h5" sx={styles.searchBar.text}>{label}:&nbsp;<HighlightedField value={item[key]} highlight={searchTerm} /></Typography>
          ) : null)
        })}
      </Stack>
    </Stack >
  )
}

export { PartnersSearchSuggestionItem }